"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useProductAddingToBag = void 0;
var AddToBasketEvent = _interopRequireWildcard(require("@ori-events/add-to-basket"));
var AddToBasketFailedEvent = _interopRequireWildcard(require("@ori-events/add-to-basket-failed"));
var BasketUpdatedEvent = _interopRequireWildcard(require("@ori-events/basket-updated"));
var _analyticsData = require("@ori/analytics-data");
var _presentationHooks = require("@ori/presentation-hooks");
var _react = require("react");
var _contexts = require("../../contexts");
function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
const useProductAddingToBag = ()=>{
    const { products } = (0, _contexts.useDetailContext)();
    const [addingToBasket, setAddingToBasket] = (0, _react.useState)(false);
    const [productIndex, setProductIndex] = (0, _react.useState)(0);
    const [countOfSuccessfullyAdded, setCountOfSuccessfullyAdded] = (0, _react.useState)(0);
    const { onOpen, onClose, open } = (0, _presentationHooks.useDisclose)();
    const closeResult = (0, _react.useCallback)(()=>{
        onClose();
        setCountOfSuccessfullyAdded(0);
    }, [
        onClose
    ]);
    const addProductToBasket = (0, _react.useCallback)((param, index)=>{
        let { code, name, price } = param;
        window.dispatchEvent(new CustomEvent(AddToBasketEvent.Name, {
            detail: {
                itemCode: code,
                quantity: 1,
                localName: name,
                placement: _analyticsData.Placement.PersonalProductListBuyAll,
                position: index,
                formattedPrice: price === null || price === void 0 ? void 0 : price.currentFormatted
            }
        }));
    }, []);
    const processNextProduct = (0, _react.useCallback)(function() {
        let index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
        const product = products[index];
        if (product) {
            addProductToBasket(product, index);
            setProductIndex(index);
        } else {
            setAddingToBasket(false);
            setProductIndex(0);
            onOpen();
        }
    }, [
        addProductToBasket,
        onOpen,
        products
    ]);
    const onBasketUpdated = (0, _react.useCallback)(()=>{
        if (addingToBasket) {
            setCountOfSuccessfullyAdded((prev)=>prev + 1);
            processNextProduct(productIndex + 1);
        }
    }, [
        addingToBasket,
        processNextProduct,
        productIndex
    ]);
    const onAddToBasketFailed = (0, _react.useCallback)(()=>{
        if (addingToBasket) {
            processNextProduct(productIndex + 1);
        }
    }, [
        addingToBasket,
        processNextProduct,
        productIndex
    ]);
    const onAddProductsToBasket = (0, _react.useCallback)(()=>{
        if (!addingToBasket) {
            setAddingToBasket(true);
            processNextProduct();
        }
    }, [
        addingToBasket,
        processNextProduct
    ]);
    const events = (0, _react.useMemo)(()=>[
            {
                name: AddToBasketFailedEvent.Name,
                listener: onAddToBasketFailed
            },
            {
                name: BasketUpdatedEvent.Name,
                listener: onBasketUpdated
            }
        ], [
        onAddToBasketFailed,
        onBasketUpdated
    ]);
    (0, _presentationHooks.useGlobalEvents)(events);
    return {
        addingToBasket,
        countOfSuccessfullyAdded,
        open,
        onClose: closeResult,
        onAddProductsToBasket
    };
};
exports.useProductAddingToBag = useProductAddingToBag;
